import React, { useState, useEffect } from 'react';
import { Modal, CallBackSelector } from '@wajeez-web/components/ui';
import { Content } from '@wajeez-web/core/api-base';
import { DatePickerInput } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import {
  ContentEntityActions,
  useContentSelector,
} from '@wajeez-web/stores/content';
import { useCommonDispatch } from '@wajeez-web/stores/common';
interface DailyContentModalProps
  extends CommonModalProps<Content.AddDailyContentToSpecificDateInput> {
  date?: string;
  selectedContentType?: string | undefined;
}
const DailyContentModal: React.FC<DailyContentModalProps> = ({
  isOpen,
  onClose,
  date,
  selectedContentType,
  onSubmit,
}) => {
  const dispatch = useCommonDispatch();

  const [contentEntitySelectedType, setContentEntitySelectedType] =
    useState<string>(selectedContentType || 'BOOK');
  const [contentCollectionEntityTypes, setContentCollectionEntityTypes] =
    useState<string[]>([]);
  const [contentEntitySelected, setContentEntitySelected] = useState<{
    contentEntityId: string;
    title: string;
    date?: string;
  }>({ contentEntityId: '', title: '', date: date });

  const addDailyContentState = useContentSelector(
    ({ dailyContent }) => dailyContent.updatingStatus
  );

  useEffect(() => {
    selectedContentType && setContentEntitySelectedType(selectedContentType);
  }, [selectedContentType]);

  const searechedInputaction = (val: string) => {
    return dispatch(
      ContentEntityActions.searchContentEntityPaginatedAsync({
        ContentEntityTypeNameSearchText: val || '',
        ContentItemType: contentEntitySelectedType,
        page: 1,
        pageSize: 100,
      })
    ).then((res) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return res?.payload?.map(
        (item: {
          id: number;
          title: string;
          authors: string[] | undefined;
        }) => {
          const authors = item.authors;

          return {
            label:
              item.title +
              (authors?.length || 0 > 1
                ? ` (${authors?.join(', ')})`
                : authors?.[0]
                ? ` (${authors?.[0]})`
                : ''),
            value: item.id,
          };
        }
      );
    });
  };

  const updateDate = () => {
    setContentEntitySelected({ ...contentEntitySelected, date });
  };

  useEffect(() => {
    date && updateDate();
  }, []);

  return (
    <Modal
      title={'Add Free Content'}
      open={isOpen}
      onClose={onClose}
      onSubmit={() => onSubmit && onSubmit(contentEntitySelected)}
      loading={addDailyContentState === 'loading'}
      fontClassName="font-[Tajawal]"
    >
      <div className="space-y-3">
        <CallBackSelector
          // inputValue={searchedContentEntity}
          onSearch={searechedInputaction}
          label={'Content'}
          onChange={(name, value: any) => {
            setContentEntitySelected({
              ...contentEntitySelected,
              title: value.label,
              contentEntityId: value.value,
            });
          }}
          name="contentEntity"
          value={
            contentEntitySelected
              ? {
                  label: contentEntitySelected?.title,
                  value: contentEntitySelected?.contentEntityId,
                }
              : undefined
          }
          placeholder="Select Content"
        />
        <div className="flex flex-wrap  space-s-2">
          {contentCollectionEntityTypes.map((item) => (
            <div
              key={item}
              onClick={() => setContentEntitySelectedType(item)}
              className={`py-2 px-2 text-xs cursor-pointer ${
                item === contentEntitySelectedType
                  ? ' bg-primary text-white'
                  : 'bg-ring-color'
              } mt-2 rounded-full`}
            >
              {item}
            </div>
          ))}
        </div>
        <DatePickerInput
          onChange={(name, value) => {
            console.log(value);

            setContentEntitySelected({
              ...contentEntitySelected,
              date: value,
            });
          }}
          name="date"
          value={contentEntitySelected?.date}
        />
      </div>
    </Modal>
  );
};
export default DailyContentModal;
